import { useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'

/**
 * Hook to scroll to an element by id
 * @param elementId - The id of the element to scroll to
 * @param removeParamFromUrl - Whether to remove the scroll-to param from URL after scrolling
 */
export const useScrollTo = (
  elementId?: string | null,
  { removeParamFromUrl = false }: { removeParamFromUrl?: boolean } = {} // options
) => {
  const [_, setSearchParams] = useSearchParams()
  useEffect(() => {
    if (!elementId) return

    const targetElement = document.getElementById(elementId)
    if (targetElement) {
      targetElement.scrollIntoView({ behavior: 'smooth' })

      if (removeParamFromUrl) {
        const params = new URLSearchParams(window.location.search)
        params.delete('scroll-to')
        setSearchParams(params)
      }
    }
  }, [elementId])
}
